import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Product} from "../../interface/product";
import {OutOfStockTransmissionService} from "../../../raintree/transmission/out-of-stock-transmission.service";
import {ToastMessageService} from "../../../services/toast-message.service";

@Component({
  selector: 'fb-out-of-stock-notify-dialog',
  templateUrl: './out-of-stock-notify-dialog.component.html',
  styleUrls: ['./out-of-stock-notify-dialog.component.scss']
})
export class OutOfStockNotifyDialogComponent implements OnInit {

	public quantity: number = 1;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { notificationId: number, product: Product },
		private _dialogRef: MatDialogRef<OutOfStockNotifyDialogComponent>,
		private _api: OutOfStockTransmissionService,
		private _toastService: ToastMessageService
	) {
	}

	ngOnInit() {

	}

	public onClose(): void {
		this._toastService.success(
			'You have been added to our waitlist',
			'Thank you for your input. Check your email for further information'
		);
		this._dialogRef.close();
	}

	public submit(): void {
		if(this.quantity > 0) {
			this._api.updateOutOfStockNotificationQuantity(
				{ quantity: this.quantity, requestId: this.data.notificationId },
				() => {},
				() => {},
				() => {
					this._toastService.success(
						'Quantity updated successfully.',
						'Thank you for your input'
					);
					this._dialogRef.close();
				},
				() => {},
				() => {}
			)
		}
		else {
			this.onClose();
		}
	}
}
